import { Component, Input } from '@angular/core';
import { ProjectGroupMetaInformation } from '../../interfaces/project-group-meta-information';
import { findMetaInformationDescription } from '../../functions/meta-information-label';

/**
 * Zeigt die zu einer Rasterposition (x/y) gepflegte Metainformation (description) an.
 * Ist keine gepflegt, wird nichts gerendert.
 * layout = 'stacked' (über einem Namen, zentriert) | 'inline' (neben einem Namen).
 */
@Component({
  selector: 'avs-station-meta-info',
  templateUrl: './station-meta-info.component.html',
  styleUrls: ['./station-meta-info.component.css']
})
export class StationMetaInfoComponent {
  @Input() metaInformation?: ProjectGroupMetaInformation[];
  @Input() x?: number;
  @Input() y?: number;
  @Input() layout: 'stacked' | 'inline' = 'stacked';

  public get description(): string | undefined {
    if (this.x === undefined || this.y === undefined) {
      return undefined;
    }
    return findMetaInformationDescription(this.metaInformation, this.x, this.y);
  }
}
